"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgoraAttendeeTile = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _AttendeeDisabledCamera = _interopRequireDefault(require("./AttendeeDisabledCamera"));
var _StudioLogger = require("@studio/logger/StudioLogger");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
var LOG = new _StudioLogger.StudioLogger('agora-attendee-tile');
var THUMB_WIDTH = 200;
var THUMB_HEIGHT = 112;
var THUMB_CREATION_TIMEOUT = 3000;
/**
 * Component that renders video tiles for attendees in an Agora video call.
 * Uses direct track.play() method instead of specialized track components.
 *
 * @component
 * @param {Object} props - The component props
 * @param {string} props.attendeeId - Unique identifier for the attendee
 * @param {Object} props.attendeeTiles - Object mapping attendee IDs to their video tracks
 * @param {boolean} [props.isCameraOn=true] - Whether the attendee's camera is enabled
 * @param {boolean} props.isLocalAttendee - Whether this tile represents the local user
 * @param {function} [props.onThumbnailReady] - Callback function to receive thumbnail data URL
 * @param {boolean} [props.shouldMirrorVideo=false] - Whether to mirror the video (for local attendee)
 * @returns {JSX.Element} The rendered video tile component
 */
var AgoraAttendeeTile = exports.AgoraAttendeeTile = function AgoraAttendeeTile(_ref) {
  var _videoTrack$_config;
  var attendeeId = _ref.attendeeId,
    attendeeTiles = _ref.attendeeTiles,
    _ref$isCameraOn = _ref.isCameraOn,
    isCameraOn = _ref$isCameraOn === void 0 ? true : _ref$isCameraOn,
    isLocalAttendee = _ref.isLocalAttendee,
    onThumbnailReady = _ref.onThumbnailReady,
    _ref$shouldMirrorVide = _ref.shouldMirrorVideo,
    shouldMirrorVideo = _ref$shouldMirrorVide === void 0 ? false : _ref$shouldMirrorVide;
  var videoContainerRef = (0, _react.useRef)(null);
  var thumbnailCreatedRef = (0, _react.useRef)(false);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isVideoLoaded = _useState2[0],
    setIsVideoLoaded = _useState2[1];
  var videoTrack = attendeeTiles[attendeeId];
  var mediaStreamTrackId = videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.getMediaStreamTrack().id;
  var cameraId = videoTrack === null || videoTrack === void 0 || (_videoTrack$_config = videoTrack._config) === null || _videoTrack$_config === void 0 ? void 0 : _videoTrack$_config.cameraId;
  var userBackground = videoTrack === null || videoTrack === void 0 ? void 0 : videoTrack.userBackground;
  var isScreenShare = attendeeId === null || attendeeId === void 0 ? void 0 : attendeeId.includes('#content');
  if (!attendeeId) {
    LOG.warn('Disabling video tile due to missing attendeeId');
  }
  (0, _react.useEffect)(function () {
    var createThumbnail = function createThumbnail() {
      if (!isScreenShare) return;
      if (!onThumbnailReady) return;
      if (!videoTrack || !videoContainerRef.current) {
        LOG.warn('Cannot generate thumbnail: missing video track or canvas or callback');
        return;
      }
      try {
        var videoElement = videoContainerRef.current;
        if (!videoElement) {
          LOG.warn('Cannot generate thumbnail: video element not found');
          return;
        }
        if (thumbnailCreatedRef.current) return;
        var canvas = document.createElement('canvas');
        canvas.width = THUMB_WIDTH;
        canvas.height = THUMB_HEIGHT;
        canvas.getContext('2d').drawImage(videoElement, 0, 0, THUMB_WIDTH, THUMB_HEIGHT);
        onThumbnailReady(canvas.toDataURL('image/png'));
        thumbnailCreatedRef.current = true;
      } catch (error) {
        LOG.error('Error generating thumbnail:', error);
      }
    };
    var timerId = setTimeout(createThumbnail, THUMB_CREATION_TIMEOUT);
    return function () {
      clearTimeout(timerId);
    };
  }, [videoTrack, onThumbnailReady]);
  (0, _react.useEffect)(function () {
    var videoElement = videoContainerRef.current;
    var startVideo = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var mediaStreamTrack, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(isCameraOn && videoTrack && videoContainerRef.current)) {
                _context.next = 4;
                break;
              }
              LOG.info('Starting video for', attendeeId);
              _context.prev = 1;
              mediaStreamTrack = videoTrack.getMediaStreamTrack();
              videoElement.srcObject = new MediaStream([mediaStreamTrack]);
              _context.next = 2;
              return videoElement.play();
            case 2:
              setIsVideoLoaded(true);
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              LOG.error('Error playing video track:', _t);
              setIsVideoLoaded(false);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      }));
      return function startVideo() {
        return _ref2.apply(this, arguments);
      };
    }();
    startVideo();
    return function () {
      if (videoTrack && videoElement) {
        videoTrack.stop();
        videoElement.srcObject = null;
        setIsVideoLoaded(false);
      }
    };
  }, [videoTrack, isCameraOn, cameraId, userBackground, mediaStreamTrackId]);
  if (!isCameraOn || !attendeeId) return /*#__PURE__*/_react["default"].createElement(_AttendeeDisabledCamera["default"], null);
  return /*#__PURE__*/_react["default"].createElement("video", {
    ref: videoContainerRef,
    "data-testid": "video-tile-".concat(attendeeId),
    id: "video-tile-".concat(attendeeId),
    className: "video-container ".concat(isLocalAttendee ? 'local-video' : 'remote-video'),
    style: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
      backgroundColor: isVideoLoaded || isScreenShare ? 'transparent' : 'black',
      objectFit: isScreenShare ? 'contain' : 'cover',
      transform: shouldMirrorVideo ? 'scaleX(-1)' : 'none'
    }
  });
};
AgoraAttendeeTile.propTypes = {
  attendeeId: _propTypes["default"].string,
  attendeeTiles: _propTypes["default"].object.isRequired,
  isCameraOn: _propTypes["default"].bool,
  isLocalAttendee: _propTypes["default"].bool.isRequired,
  onThumbnailReady: _propTypes["default"].func,
  shouldMirrorVideo: _propTypes["default"].bool
};